<template>
  <v-dialog width="620" v-model="dialog" persistent scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>THÊM HỆ ĐÀO TẠO</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-6 pt-6 pb-0">
        <v-form v-bind="this.$attrs" ref="form">
          <v-text-field
            label="Tên hệ đào tạo"
            v-model="name"
            outlined
            required
            :rules="[$rules.required]"
            class="required"
          ></v-text-field>
          <v-text-field
            label="Tên viết tắt"
            required
            type="tel"
            v-model="acronym"
            :rules="[$rules.required]"
            class="required"
            outlined
          ></v-text-field>
          <v-select
            label="Khối tuyển sinh"
            :items="gradeOptions"
            item-text="label"
            item-value="value"
            v-model="grade"
            outlined
            :rules="[$rules.gradeSelect]"
            class="required"
          ></v-select>
          <v-select
            label="Phân loại"
            :items="types"
            item-text="name"
            item-value="id"
            v-model="type"
            outlined
            :rules="[$rules.selectRequired]"
            class="required"
          ></v-select>
          <v-textarea label="Ghi chú" v-model="note" outlined></v-textarea>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn color="blue darken-4" outlined @click="close">Hủy </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" dark @click="submit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
  props: {
    state: Boolean,
    types: Array
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) this.loading = false
    }
  },
  computed: {
    ...mapGetters('auth', ['user'])
  },
  data() {
    return {
      dialog: false,
      loading: false,
      name: '',
      acronym: '',
      grade: '',
      note: '',
      type: '',
      gradeOptions: [
        {label: 'Khối 6', value: '6'},
        {label: 'Khối 10', value: '10'}
      ]
    }
  },
  methods: {
    ...mapActions('product', ['createProduct']),
    close() {
      this.$emit('closeDialog')
      this.$refs.form.resetValidation()
    },
    async submit() {
      if (this.$refs.form.validate()) {
        let data = {
          name: this.name,
          acronym: this.acronym,
          grade: this.grade,
          note: this.note,
          productType: this.type,
          status: 'active'
        }

        const createProd = await this.createProduct({...data})

        if (createProd) {
          this.$emit('refresh')
          this.resetForm()
          this.close()
        } else {
          this.$alert.error('Lỗi tạo sản phẩm')
        }
      }
    },
    resetForm() {
      this.name = ''
      this.acronym = ''
      this.grade = ''
      this.note = ''
      this.type = ''
    }
  }
}
</script>

<style>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 2px !important;
}
</style>
